/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import * as Utils from '@Cyclope-Utils/index';
import {ReplayActionFail, ReplayActionInProgress, ReplayActionSuccess} from '@tunnel-store/index';
import {ReplayDownloadActionFail, ReplayDownloadActionInProgress, ReplayDownloadActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';

/**
 * @function ReplayActionCreator
 * @param { number } incidentId
 * @return {Promise<any>}  Promise
 */
export function ReplayActionCreator(incidentId: number): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ReplayActionInProgress());


        await Utils.replayOfIncident(incidentId)
        .then((response: any)=> {
      if (response.ok) {
        /**
         * @constant
         * @name contentHeader
         * @type string
         */
        const contentHeader: string = response.headers.get('content-type');

        { /* Comparer les valeurs */
        }
        if (contentHeader && contentHeader !== null &&
            contentHeader.indexOf('application/json') !== -1) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat en JSON  */
            }
            response.json().then(
                (data: any) => dispatch(ReplayActionSuccess(
                    data)));  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.json().then(
                (text: any) => dispatch(
                    ReplayActionSuccess([])))  // État du state : resultat final
          }
        }
        if (contentHeader === null || contentHeader === undefined) {
          if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(
                    ReplayActionSuccess([])))  // État du state : resultat final
          }
        }
      } else {
        throw ({
          message: response.statusText,
          status: response.status,
          url: response.url,
          headers: response.headers
        });
      }}).catch( (error: any) => {
                dispatch(ReplayActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                Utils.fetchLogs(error.url,error.message,error.status,error.headers)
            })
  }
}


/**
 * @function ExtractorVideoActionCreator
 * @param { number } incidentId
 * @param { string } label
 * @param { string } startTime
 * @return {Promise<any>}  Promise
 */
export function ReplayDownloadActionCreator(
    incidentId: number, label: string, startTime: string,
    code: string): (dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ReplayDownloadActionInProgress());

    await Utils.replayOfIncident(incidentId)
        .then((res: any) => {
          if (res.ok) {
            /**
             * @constant
             * @name contentType
             * @type string
             */
            const contentType: any = res.headers.get('content-type');

            { /** vérification du tyde des entêtes */
            }

            if (contentType && contentType.indexOf('application/json') !== -1) {
              res.json().then(
                  (urlString: any) => {

                      fetch(urlString).then(resp => resp.blob()).then(blob => {
                        const file = new Blob([blob], { type: 'video/mp4' });

                        const Link = document.createElement('a');
                        Link.style.display = 'none';
                        Link.href = window.URL.createObjectURL( file );
                        Link.download = incidentId + '_' + label.toLowerCase() +
                            '_' + code + '_' + startTime + '.mp4';
                        document.body.appendChild(Link);
                        Link.click();
                        Link.remove();
                        dispatch(ReplayDownloadActionSuccess(
                            ' video has been daowload ' + Math.random()));
                      })

                  });

            } else {
              res.text().then((text: any) => {
                /**
                 * @description : Retourne un objet de type any { utilisateur }
                 * @const
                 * @name data
                 * @type { any }
                 */
                if (text.length >= 1) {
                  dispatch(ReplayActionSuccess(JSON.stringify(text)))
                } else {
                  Utils.localStorageClear();
                  dispatch(ReplayDownloadActionFail({}))
                }
              })
            }

          } else {
            throw Error(res.statusText + ', server status:' + res.status);
          }
        })
        .catch(
            (error: any) => dispatch(ReplayDownloadActionFail(
                error.message + ' ,random value:' + Math.random())))
  }
}


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/actions/replay/index.ts